module.exports = __webpack_public_path__ + "static/media/promo-close.341fb7e4.svg";